import Index from './Index';
import Show from './Show';
import Create from './Create';
import Csat from './Csat';
import {
  Switch,
  Route,
  useRouteMatch,
} from "react-router-dom";

const Tickets = (props) => {
  const { path } = useRouteMatch();
  const theme = props.theme;

  return (
    <Switch>
      <Route exact path={`${path}`}>
        <Index theme={theme} setShowMenu={props.setShowMenu} />
      </Route>
      <Route exact path={`${path}/csat`}>
        <Csat theme={theme} setShowMenu={props.setShowMenu} />
      </Route>
      <Route exact path={`${path}/novo`}>
        <Create theme={theme} setShowMenu={props.setShowMenu} />
      </Route>
      <Route exact path={`${path}/:ticket_id`}>
        <Show theme={theme} setShowMenu={props.setShowMenu} />
      </Route>
    </Switch>
  );
};

export default Tickets;
